/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import {
    SET_ERROR,
    CORE_AUTH_VERIFY_SUCCESS,
    CORE_AUTH_VERIFY_FAILURE,
} from '../types'

import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const initialStateCallAPI = {
    isLoading: false,
    hasError: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
},
    initialStateArray = []

export default {
    errorList: (state = initialStateArray, action) => {
        switch (action.type) {
            case SET_ERROR:
                let newError = []
                if (action && Array.isArray(action.error)) {
                    newError = action.error
                }
                return newError

            case CORE_AUTH_VERIFY_SUCCESS:
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { errors, result } = action.payload
                    let newError = []
                    if (!result) {
                        if (Array.isArray(errors)) {
                            errors.map((e) => {
                                toast.error(e.message, {
                                    position: 'top-right',
                                    autoClose: 5000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined
                                })
                                return e
                            })
                        }
                    }

                    return newError
                }
                return state
            case CORE_AUTH_VERIFY_FAILURE:
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { code, message, statusText, statusCode } = action.payload
                    const { url } = action
                    let newError = []
                    newError.push({
                        code: code ? code : '404',
                        message,
                        isShow: false,
                        statusText,
                        statusCode,
                        url
                    })
                    newError.map((e) => {
                        toast.error(e.code + ',' + e.message, {
                            position: 'top-right',
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined
                        })
                        return e
                    })
                }
                return state
            default:
                return state
        }
    },
    isLoading: (state = false, action) => {
        switch (action.type) {
            // case CORE_GET_TASKS_BY_ID_REQUEST:
            //     return true
            // case CORE_GET_TASKS_BY_ID_SUCCESS:
            //     return false
            // case CORE_GET_TASKS_BY_ID_FAILURE:
            //     return false
            default:
                return state
        }
    },
    reducerCallAPI: (state = initialStateCallAPI, action) => {
        switch (action.type) {
            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js